export default [{"url":"https://micky-look-0.api.invexerp.io","name":"Branch 1","port":"5039","isStore":true,"isHQ":true}]